import React from 'react';
import {useLocation} from 'react-router-dom'
import qs from 'query-string'
import {FormElementProps} from "@q4us-sw/q4us-ui/lib/Form";
import {message, Typography, Card, Select, Space, Row, Col, Descriptions, notification, Spin, Checkbox} from 'antd';
import {Trans, withTranslation} from "react-i18next";
import i18 from "../i18";
import {FCConfirmationDataElement} from './FCConfirmationData';
import {RestrictedOSSSaleElement} from './RestrictedIOSSSale';
import {getFeData} from "../api/api";
import '../styles/confirmationPage.css';

const ConfirmationPage = (props: any) => {

    const [loading, setLoading] = React.useState(true)
    const [lang, setLang] = React.useState(i18.language || 'en')
    const [value, setValue] = React.useState<{ [key: string]: any }>({});
    const [showFCConfirmation, setshowFCConfirmation] = React.useState(true);

    let location = useLocation();
    const {token = "", redirect_uri = "", decline_uri = ''} = qs.parse(location.search);
    const redirectURI = decodeURIComponent(`${redirect_uri}`);
    const declineURI = decodeURIComponent(`${decline_uri}`) || '';

    const load = async () => {
        const {data} = await getFeData(`${token}`) as { [key: string]: any };
        setValue(data);
        setshowFCConfirmation((!data.fcc_order_ioss_sale_over_threshold || data.fcc_order_ioss_sale_over_threshold === 'allowed'))
    };

    const childComponentLoaded = () => {
        setLoading(false);
    };

    const toggleShowFCConfirm = () => {
        setshowFCConfirmation(!showFCConfirmation);
    };

    React.useEffect(() => {
        load().catch(e => notification.warn({message: e.message}));
    }, []);

    return <React.Fragment>
        <Space style={{display: "grid", placeItems: "center", verticalAlign: 'middle'}} size={0}>
            <Space direction={"vertical"} style={{ verticalAlign: "middle"}} align={'center'} size={0}>
                <Spin spinning={loading}>
                    <Card
                        key={lang}
                        size={"small"}
                        className={`confirm-card`}
                        title={showFCConfirmation && <div>
                            <Space style={{width: '100%'}}>
                                <Typography.Title level={2} className={"confirmationTitle"}>
                                    <Trans i18nKey={'confirmation.title'} defaults={'Confirm Representation'}/>
                                </Typography.Title>
                            </Space>
                        </div>}
                        extra={[
                            <Select showSearch optionFilterProp={'children'} className={"select"}
                                    value={lang} onChange={async (e) => {
                                await i18.changeLanguage(e);
                                setLang(e);
                            }}>
                                <Select.Option key={'en'} value={'en'} className={'selectOption'}>English</Select.Option>
                                <Select.Option key={'fr'} value={'fr'} className={'selectOption'}>French</Select.Option>
                                <Select.Option key={'fi'} value={'fi'} className={'selectOption'}>Finnish</Select.Option>
                                <Select.Option key={'nl'} value={'nl'} className={'selectOption'}>Dutch</Select.Option>
                                <Select.Option key={'ru'} value={'ru'} className={'selectOption'}>Russian</Select.Option>
                                <Select.Option key={'sv'} value={'sv'} className={'selectOption'}>Swedish</Select.Option>
                                <Select.Option key={'de'} value={'de'} className={'selectOption'}>German</Select.Option>
                            </Select>
                        ]}
                    >
                        {showFCConfirmation &&
                        <FCConfirmationDataElement token={token} redirectURI={redirectURI} declineURI={declineURI} data={value} setLoadedCb={childComponentLoaded}/>}

                        {!showFCConfirmation &&
                        <RestrictedOSSSaleElement token={token} redirectURI={redirectURI} declineURI={declineURI} data={value} setLoadedCb={childComponentLoaded} toggleShowFCConfirm={toggleShowFCConfirm}/>}

                    </Card>
                </Spin>
            </Space>
        </Space>


    </React.Fragment>
}


export const ConfirmationPageElement = withTranslation()(ConfirmationPage)